exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entry .post-text-container[data-v-dcddb09a] {\n  height: 4.5em;\n  overflow: hidden;\n}\n.entry .info-summary span[data-v-dcddb09a] {\n  color: white;\n}", ""]);

// exports
